// Customer-facing copy based on the supplied Darajat 2.0 product brief.
export const darajatContent = {
  ar: {
    name: "درجات",
    eyebrow: "لإدارات المدارس • تطبيق سطح مكتب",
    title: "نتائج الطلبة وتأييداتهم، من مكان واحد.",
    intro:
      "أدخل الدرجات، احسب النتائج، وتابع إحصائيات المدرسة ونسب النجاح، ثم أصدر التأييدات الفردية والجماعية. برنامج مكتبي بواجهة عربية يجمع أعمال النتائج في مدرستك، ويحفظ بياناتك محليًا على جهازك.",
    download: "حمّل التجربة المجانية",
    trial: "تجربة 14 يومًا مع بيانات تجريبية",
    explore: "شاهد البرنامج",
    back: "العودة إلى المنتجات",
    nav: ["الميزات", "صور البرنامج", "متطلبات التشغيل", "أسئلة شائعة"],
    facts: ["Windows", "واجهة عربية", "بيانات محلية", "الإصدار 2.0"],
    benefitsTitle: "من سجل الطالب إلى التأييد، بخطوات مترابطة.",
    benefitsIntro:
      "أقلّ تكرارًا لإدخال البيانات، وأكثر تنظيمًا للنتائج والمستندات اليومية.",
    features: [
      [
        "mdi:calculator-variant-outline",
        "نتائج تُحتسب تلقائيًا",
        "احتساب المجموع والمعدل والنجاح أو الرسوب من درجات المواد، مع التحقق من حدود الدرجات وتمييز غير الناجح منها.",
      ],
      [
        "mdi:file-document-check-outline",
        "تأييدات جاهزة للإصدار",
        "تعبئة بيانات الطالب ودرجاته في مستند Word، وتحويل الدرجات إلى كلمات عربية، مع تحديد الجهة والعدد والتاريخ.",
      ],
      [
        "mdi:printer-outline",
        "فردي أو جماعي",
        "أصدر تأييد طالب واحد، أو جهّز مجموعة كاملة بحسب السنة والدور والنتيجة، مع عرض عدد الطلبة قبل التنفيذ.",
      ],
      [
        "mdi:magnify",
        "اعثر على السجل بسرعة",
        "ابحث بالاسم العربي وصفِّ النتائج بحسب السنة وحالة النجاح، ثم انتقل مباشرة إلى التعديل أو إصدار التأييد.",
      ],
      [
        "mdi:chart-box-outline",
        "إحصائيات تفصيلية ونسب النجاح",
        "تابع نسب النجاح على مستوى المدرسة والاختصاص والمادة، وقارن الفترات وصدّر الإحصائيات إلى تقرير Word.",
      ],
      [
        "mdi:file-edit-outline",
        "قوالب تناسب مدرستك",
        "قوالب Word مستقلة للذكور والإناث ولكل نوع دراسة، قابلة للتعديل مع إمكانية استعادة القالب الأصلي.",
      ],
    ],
    galleryTitle: "تعرّف على البرنامج من الداخل.",
    statisticsTitle: "صورة واضحة عن نتائج مدرستك ونسب النجاح.",
    statisticsIntro:
      "من النسبة العامة للمدرسة إلى تفاصيل كل اختصاص ومادة، اجمع الأرقام التي تحتاجها للمراجعة وإعداد التقارير في شاشة واحدة.",
    statisticsPoints: [
      "إجمالي المشاركين والناجحين ونسبة النجاح العامة للمدرسة.",
      "عدد المشاركين والناجحين ونسبة النجاح لكل اختصاص ولكل مادة.",
      "تحديد السنة الدراسية والدور، مع خيار تضمين طلبة المحاولات أو استبعادهم.",
      "مقارنة نسب النجاح زمنيًا وإظهار مقدار التغيّر بين الفترات.",
      "تصدير الإحصائيات إلى تقرير Word وفتحه مباشرة.",
    ],
    statisticsLink: "شاهد شاشة الإحصائيات",
    galleryIntro:
      "لقطات فعلية من واجهته العربية. اختر شاشة واضغط على الصورة لتكبيرها.",
    shots: [
      [
        "statistics.png",
        "الإحصائيات ونسب النجاح",
        "نسب النجاح، من ملخص المدرسة إلى تفاصيل المواد.",
        "اعرض المشاركين والناجحين ونسب النجاح حسب الاختصاص والمادة، وحدّد السنة والدور وضمّن طلبة المحاولات عند الحاجة، ثم صدّر تقرير Word.",
      ],
      [
        "results.png",
        "البحث والنتائج",
        "من الاسم إلى السجل المطلوب.",
        "ابحث عن الطالب، راجع معدّله ونتيجته، ثم افتح بياناته للتعديل أو إصدار التأييد.",
      ],
      [
        "printing.png",
        "إصدار التأييد",
        "تفاصيل المستند تحت سيطرتك.",
        "حدّد الجهة والعدد والتاريخ قبل تجهيز التأييد، مع إمكانية إصداره دون تاريخ.",
      ],
      [
        "import-export.png",
        "الاستيراد والتصدير",
        "ابدأ من بياناتك الموجودة.",
        "استخدم نموذج Excel المتوافق أو ملفات CSV لنقل بيانات الطلبة، مع الإبقاء على السجلات الموجودة عند الاستيراد.",
      ],
    ],
    zoom: "تكبير لقطة الشاشة",
    close: "إغلاق الصورة",
    stagesTitle: "خطة مرنة لكل مرحلة دراسية.",
    stagesIntro:
      "أدر الفروع والاختصاصات والمواد حسب سنة الدراسة، وانسخ خطة السنة السابقة بدل إعدادها من جديد.",
    stages: ["الابتدائية", "المتوسطة", "الإعدادية", "المهنية"],
    workflowTitle: "ابدأ بثلاث خطوات.",
    steps: [
      ["جهّز مدرستك", "أدخل بيانات المدرسة وحدّد نوع الدراسة والخطة والمواد."],
      [
        "أضف بيانات الطلبة",
        "أدخل الطلبة ودرجاتهم أو استورد ملف Excel أو CSV متوافقًا.",
      ],
      ["راجع وأصدر", "ابحث عن النتائج، تابع الإحصائيات، وجهّز التأييدات."],
    ],
    requirementsTitle: "ما الذي تحتاجه لتشغيل درجات؟",
    requirementsIntro:
      "تطبيق مكتبي لنظام Windows. لا يحتاج إلى خادم قاعدة بيانات منفصل.",
    requirements: [
      ["نظام التشغيل", "Microsoft Windows"],
      ["بيئة التشغيل", "Microsoft .NET Framework 4.8"],
      [
        "Microsoft Excel",
        "مطلوب لاستيراد وتصدير XLSX. يمكن استخدام CSV دون Excel.",
      ],
      [
        "Microsoft Word",
        "مطلوب لتعديل القوالب، وموصى به لفتح التأييدات ومعاينتها وطباعتها.",
      ],
      [
        "الاتصال بالإنترنت",
        "غير مطلوب للوظائف الأساسية؛ تحتاجه لفتح روابط الدعم وطلب التفعيل.",
      ],
      [
        "حفظ البيانات",
        "محليًا في حساب Windows، مع صلاحية الكتابة ومساحة للسجلات والمستندات.",
      ],
    ],
    privacyTitle: "بيانات المدرسة تبقى قريبة منك.",
    privacyText:
      "تُحفظ سجلات المدرسة والطلبة محليًا على جهازك. يمكنك إنجاز الإدخال والبحث والإحصائيات وإصدار التأييدات دون اتصال دائم بالإنترنت.",
    faqTitle: "قبل أن تبدأ.",
    faqs: [
      [
        "ماذا تتضمن التجربة المجانية؟",
        "تجربة لمدة 14 يومًا مع بيانات تجريبية جاهزة لاستكشاف البرنامج. تستخدم التجربة قاعدة بيانات منفصلة عن قاعدة النسخة المفعّلة.",
      ],
      [
        "هل يعمل على الهاتف أو macOS؟",
        "درجات برنامج سطح مكتب لنظام Windows، وليس تطبيق هاتف أو خدمة تعمل في المتصفح.",
      ],
      [
        "هل يمكن إدارة أكثر من سنة دراسية؟",
        "نعم. تُدار الخطط والسجلات بحسب السنة الدراسية، ويمكن نسخ خطة سنة سابقة إلى سنة جديدة.",
      ],
      [
        "هل أحتاج إلى Word وExcel معًا؟",
        "Excel مطلوب لملفات XLSX، بينما CSV لا يحتاجه. Word مطلوب لتعديل القوالب وموصى به لفتح وطباعة مستندات التأييد.",
      ],
      [
        "كيف أفعّل البرنامج بعد التجربة؟",
        "تواصل عبر واتساب وأرسل رمز الجهاز الظاهر في شاشة التفعيل، ثم استخدم ملف الترخيص المخصص لجهازك. تواصل لمعرفة خيارات الترخيص المتاحة.",
      ],
    ],
    ctaTitle: "جرّب درجات على جهاز مدرستك.",
    ctaText: "استكشف سير العمل ببيانات تجريبية قبل طلب التفعيل.",
    support: "الاستفسار عبر واتساب",
    release: "الإصدار 2.0 · 7 سبتمبر 2026",
    screenshotNote: "صور من البرنامج",
  },
  en: {
    name: "Darajat",
    eyebrow: "For school administrators • Desktop software",
    title: "Student results and confirmations, in one place.",
    intro:
      "Enter grades, calculate results, track school statistics and pass rates, and prepare individual or batch confirmations. An Arabic desktop application that brings school results together and stores your records locally.",
    download: "Download the free trial",
    trial: "14-day trial with sample data",
    explore: "Explore the application",
    back: "Back to products",
    nav: ["Features", "Screenshots", "Requirements", "FAQs"],
    facts: ["Windows", "Arabic interface", "Local data", "Version 2.0"],
    benefitsTitle: "From a student record to a finished document.",
    benefitsIntro:
      "Less repeated data entry. Better organized results and everyday documents.",
    features: [
      [
        "mdi:calculator-variant-outline",
        "Automatically calculated results",
        "Calculate totals, averages, and pass or fail status, with grade-range checks and visual indicators for grades below the pass mark.",
      ],
      [
        "mdi:file-document-check-outline",
        "Ready-to-issue confirmations",
        "Fill Word documents with student details and grades, including grades written in Arabic words, recipient, reference number, and date.",
      ],
      [
        "mdi:printer-outline",
        "Individual or batch output",
        "Prepare one student's confirmation or a group filtered by academic year, exam round, and result. Review the student count first.",
      ],
      [
        "mdi:magnify",
        "Find records quickly",
        "Search Arabic names, filter by academic year and result, then go directly to editing or confirmation output.",
      ],
      [
        "mdi:chart-box-outline",
        "Detailed statistics and pass rates",
        "Track pass rates by school, specialization, and subject. Compare periods and export statistics to Word reports.",
      ],
      [
        "mdi:file-edit-outline",
        "Templates for your school",
        "Customize separate Word templates by gender and school type, with the option to restore the original template.",
      ],
    ],
    galleryTitle: "Take a look inside.",
    statisticsTitle: "A clear view of your school's results and pass rates.",
    statisticsIntro:
      "From the overall school pass rate to individual subjects and specializations, find the figures you need for reviews and reports in one screen.",
    statisticsPoints: [
      "Total participants, successful students, and the overall school pass rate.",
      "Participant counts, successful students, and pass rates by specialization and subject.",
      "Filter by academic year and exam round, with the option to include or exclude retry students.",
      "Compare pass rates over time and see changes between periods.",
      "Export statistics to a Word report and open it directly.",
    ],
    statisticsLink: "View the statistics screen",
    galleryIntro:
      "Actual screenshots of the Arabic interface. Choose a screen and select its image to enlarge.",
    shots: [
      [
        "statistics.png",
        "Statistics & pass rates",
        "From school-wide results to individual subjects.",
        "Review participants, successful students, and pass rates by specialization and subject. Choose a year and exam round, optionally include retry students, and export a Word report.",
      ],
      [
        "results.png",
        "Search & results",
        "From a name to the right record.",
        "Find a student, review their average and result, then edit the record or prepare a confirmation.",
      ],
      [
        "printing.png",
        "Confirmation output",
        "Control the document details.",
        "Set the recipient, reference number, and date, or choose to issue the confirmation without a date.",
      ],
      [
        "import-export.png",
        "Import & export",
        "Start with the data you already have.",
        "Use a compatible Excel template or CSV files to transfer student data while preserving existing records during import.",
      ],
    ],
    zoom: "Enlarge screenshot",
    close: "Close image",
    stagesTitle: "Flexible plans for different school stages.",
    stagesIntro:
      "Manage branches, specializations, and subjects by academic year, and copy an existing plan into the next year.",
    stages: ["Primary", "Intermediate", "Preparatory", "Vocational"],
    workflowTitle: "Get started in three steps.",
    steps: [
      [
        "Set up your school",
        "Enter school details and select the school type, plan, and subjects.",
      ],
      [
        "Add student records",
        "Enter students and grades, or import a compatible Excel or CSV file.",
      ],
      [
        "Review and issue",
        "Find results, review statistics, and prepare confirmations.",
      ],
    ],
    requirementsTitle: "What do you need to run Darajat?",
    requirementsIntro:
      "A Windows desktop application. No separate database server required.",
    requirements: [
      ["Operating system", "Microsoft Windows"],
      ["Runtime", "Microsoft .NET Framework 4.8"],
      [
        "Microsoft Excel",
        "Required for XLSX import and export. CSV works without Excel.",
      ],
      [
        "Microsoft Word",
        "Required to edit templates; recommended to open, preview, and print confirmations.",
      ],
      [
        "Internet",
        "Not required for core functions. Needed to open support links and request activation.",
      ],
      [
        "Data storage",
        "Local Windows user storage with write access and space for records and documents.",
      ],
    ],
    privacyTitle: "Keep school records on your own device.",
    privacyText:
      "School and student records are stored locally. Data entry, search, statistics, and confirmation generation do not require a continuous internet connection.",
    faqTitle: "Before you get started.",
    faqs: [
      [
        "What is included in the free trial?",
        "A 14-day trial with sample data to explore the application. Trial data uses a separate database from the activated version.",
      ],
      [
        "Does it work on a phone or macOS?",
        "Darajat is Windows desktop software, not a mobile app or browser-based service.",
      ],
      [
        "Can I manage multiple academic years?",
        "Yes. Plans and records are organized by academic year, and you can copy an existing plan into a new year.",
      ],
      [
        "Do I need both Word and Excel?",
        "Excel is required for XLSX files, but not CSV. Word is required for template editing and recommended for opening and printing confirmations.",
      ],
      [
        "How do I activate it after the trial?",
        "Contact support on WhatsApp with the device code shown in the activation screen, then use your device-specific license file. Ask about available licensing options.",
      ],
    ],
    ctaTitle: "Try Darajat on your school's computer.",
    ctaText:
      "Explore the workflow with sample data before requesting activation.",
    support: "Enquire via WhatsApp",
    release: "Version 2.0 · September 7, 2026",
    screenshotNote: "Application screenshots",
  },
};
